import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>

      <section>
        <p>
          This Privacy Policy explains how your personal information is
          collected, used, and shared when you visit or make a purchase from
          www.charlestimmins.com (the “Site”).
        </p>
      </section>

      <section>
        <h2>Personal Information We Collect</h2>
        <p>
          When you visit the Site, we automatically collect certain information
          about your device, including your web browser, IP address, time zone,
          and some of the cookies installed on your device. As you browse the
          Site, we also collect information about the individual web pages or
          products you view, the websites or search terms that referred you to
          the Site, and how you interact with the Site. This
          automatically-collected information is referred to as “Device
          Information.”
        </p>
        <p>We collect Device Information using the following technologies:</p>
        <ul>
          <li>
            <strong>Cookies:</strong> Data files placed on your device or
            computer, often including an anonymous unique identifier. For more
            details about cookies and how to disable them, visit All About
            Cookies.
          </li>
          <li>
            <strong>Log files:</strong> Track actions occurring on the Site and
            collect data such as your IP address, browser type, Internet service
            provider, referring/exit pages, and date/time stamps.
          </li>
          <li>
            <strong>Web beacons, tags, and pixels:</strong> Electronic files
            used to track how you browse the Site.
          </li>
        </ul>
        <p>
          Additionally, when you make or attempt to make a purchase through the
          Site, we collect certain information from you, such as your name,
          billing address, shipping address, payment information (including
          credit card numbers), email address, and phone number. We refer to
          this as “Order Information.”
        </p>
        <p>
          When we use the term “Personal Information” in this Privacy Policy, it
          includes both Device Information and Order Information.
        </p>
      </section>

      <section>
        <h2>How Do We Use Your Personal Information?</h2>
        <p>We use Order Information to:</p>
        <ul>
          <li>
            Fulfill orders placed through the Site (e.g., process payment,
            arrange shipping, and provide order confirmations/invoices).
          </li>
          <li>Communicate with you.</li>
          <li>Screen orders for potential risk or fraud.</li>
          <li>
            Provide you with information or advertising about our products or
            services, in line with your preferences.
          </li>
        </ul>
        <p>We use Device Information to:</p>
        <ul>
          <li>
            Screen for potential risk or fraud (especially your IP address).
          </li>
          <li>
            Improve and optimize our Site (e.g., analyze customer browsing
            behavior and evaluate marketing campaign success).
          </li>
        </ul>
      </section>

      <section>
        <h2>Sharing Your Personal Information</h2>
        <p>
          We share your Personal Information with third parties to assist us in
          using it as described above. For example:
        </p>
        <ul>
          <li>
            We use Shopify to power our online store. You can read more about
            how Shopify uses your Personal Information here.
          </li>
          <li>
            We use Google Analytics to understand how customers use the Site.
            Learn more about how Google uses your Personal Information here. You
            can opt out of Google Analytics here.
          </li>
        </ul>
        <p>
          We may also share your Personal Information to comply with legal
          obligations, respond to subpoenas or other lawful requests, or protect
          our rights.
        </p>
      </section>

      <section>
        <h2>Do Not Track</h2>
        <p>
          Please note that we do not alter our Site’s data collection and usage
          practices when we detect a Do Not Track signal from your browser.
        </p>
      </section>

      <section>
        <h2>Your Rights</h2>
        <p>
          If you are a European resident, you have the right to access the
          personal information we hold about you and request corrections,
          updates, or deletions. To exercise this right, please contact us using
          the details below.
        </p>
        <p>
          If you are a European resident, note that we process your information
          to fulfill contracts we may have with you (e.g., placing an order) or
          to pursue our legitimate business interests. Additionally, your
          information may be transferred outside of Europe, including to Canada
          and the United States.
        </p>
      </section>

      <section>
        <h2>Data Retention</h2>
        <p>
          We retain your Order Information for our records unless you request
          its deletion.
        </p>
      </section>

      <section>
        <h2>Changes</h2>
        <p>
          We may update this Privacy Policy periodically to reflect changes to
          our practices or for other operational, legal, or regulatory reasons.
        </p>
      </section>

      <section>
        <h2>Contact Us</h2>
        <p>
          For questions about our privacy practices, to make a complaint, or for
          further information, contact us at:
        </p>
        <address>
          Charles Timmins Ltd
          <br />
          Email: charlestimmins@gmail.com
          <br />
          Address: Hazeldene, The Lane, Gate Helmsley, York, England, YO41 1JT
        </address>
      </section>
    </div>
  );
}
